/**
 * Side preview of a job (RM-118). A shadcn Sheet (right-anchored) that hosts the
 * full {@link JobDetailPage} content — the standalone `/jobs/$id` page was
 * removed in favour of this. Open state is derived from `?preview=<jobId>`
 * (see {@link useJobPreview}); closing clears the param.
 */
import { JobDetailPage } from '../../pages/JobDetail'
import { TESTID } from '../../lib/testids'
import { Sheet, SheetContent } from '../ui/sheet'

export function JobPreviewSheet({
  jobId,
  onClose,
}: {
  jobId: string | undefined
  onClose: () => void
}) {
  return (
    <Sheet
      open={jobId !== undefined}
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
    >
      <SheetContent side="right" data-testid={TESTID.jobPreviewSheet}>
        {/* JobDetailPage renders its own SheetHeader (title + close X) + body. */}
        {jobId !== undefined && <JobDetailPage id={jobId} />}
      </SheetContent>
    </Sheet>
  )
}
